// booking/utils/money.js

/**
 * 把金额字符串/number 转换为 cents
 */
export function toCents(value) {
    if (value === null || value === undefined || value === "") return 0;

    const normalized = Number(String(value).replace(",", "."));

    return Number.isFinite(normalized)
        ? Math.round(normalized * 100)
        : 0;
}

/**
 * 把 cents 转换为带两位小数的字符串
 */
export function fromCents(cents) {
    const n = Number(cents || 0);
    return (n / 100).toFixed(2);
}